import {
  Grid,
  Button,
  TextField,
  InputAdornment,
  CircularProgress,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import DownloadIcon from "@mui/icons-material/Download";
import { useNavigate } from "react-router-dom";
const SellerActions = ({
  loading,
  sellersCount,
  auxSearcher,
  setAuxSearcher,
  downloadSellers,
}) => {
  const navigate = useNavigate();
  const isDisabled = loading || sellersCount === 0;
  return (
    <>
      <Grid
        container
        spacing={2}
        alignItems="center"
        sx={{
          mt: 3,
        }}
      >
        <Grid item xs={12} md={2}>
          <Button
            size="large"
            sx={{width: "100% !important"}}
            variant="outlined"
            onClick={downloadSellers}
            disabled={isDisabled}
            startIcon={!loading && <DownloadIcon />}
          >
            {loading ? (
              <CircularProgress className="loading-btn" />
            ) : (
              sellersCount ? "Descargar" : "Sin datos"
            )}
          </Button>
        </Grid>
        <Grid item xs={12} md={2}>
          <Button
            startIcon={
              <i className="material-icons">add</i>
            }
            fullWidth
            variant="outlined"
            sx={{ marginLeft: "auto", display: "flex-start" }}
            onClick={() => navigate("/home/create-seller")}
          >
            Crear Seller
          </Button>
        </Grid>
      </Grid>
      <Grid
        container
        sx={{
          mt: 3,
        }}
      >
        <Grid item xs={12} md={4}>
          <TextField
            fullWidth
            placeholder="Buscar por nombre, rut, email..."
            value={auxSearcher}
            onChange={(e) => setAuxSearcher(e.target.value)}
            size="small"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon color="action" />
                </InputAdornment>
              ),
            }}
            sx={{
              marginTop: "0px !important",
            }}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default SellerActions;
